import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import axios from 'axios';

const apiPrefix = window.location.hostname === 'localhost' ? '' : '/api';

export const useScheduledSearches = (userId) => useQuery({
    queryKey: ['scheduledSearches', userId],
    queryFn: () =>
        axios.get(`${apiPrefix}/readAllScheduledSearchesForUserId/${userId}`, { withCredentials: true })
            .then(r => {
                const list = r.data.list_scheduled_searches || [];
                list.sort((a, b) => a.id - b.id);
                return list;
            }),
    enabled: !!userId,
});

export const useScheduledSearch = (id) => useQuery({
    queryKey: ['scheduledSearch', id],
    queryFn: () => axios.get(`${apiPrefix}/readScheduledSearch/${id}`, { withCredentials: true }).then(r => r.data),
    enabled: !!id,
});

export const useToggleScheduledSearch = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => axios.post(`${apiPrefix}/toggleScheduledSearch`, data, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['scheduledSearches'] }),
    });
};

export const useDeleteScheduledSearch = () => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: (data) => axios.post(`${apiPrefix}/deleteScheduledSearch`, data, { withCredentials: true }).then(r => r.data),
        onSuccess: () => queryClient.invalidateQueries({ queryKey: ['scheduledSearches'] }),
    });
};
